import React from 'react'
import createReactClass from 'create-react-class'
import {Form, Control, Errors} from 'react-redux-form'
import {keys} from 'ramda'
import './search-form.scss'

/* const isCheckValidLength = (val, {minLength, maxLength}) => {
  if (val) {
    if (minLength || maxLength) {
      if (minLength && maxLength) {
        return val.length >= minLength && val.length <= maxLength
      } else if (minLength) {
        return val.length >= minLength
      } else {
        return val.length <= maxLength
      }
    }
  }
  return true

} */

export default createReactClass({
  getElementType (data) {
    if (data.allowedValues) {
      return 'select'
    }
    return 'text'
  },

  getObjects (sets = {}) {
    let newSets = {}
    for (let key in sets) {
      if (keys(sets[key]).length === 0) {
        newSets[key] = sets[key]
      } else {
        for (let subKey in sets[key]) {
          let val = sets[key][subKey]
          if (val && !Array.isArray(val) && typeof val === 'object') {
            newSets[subKey] = val
          } else {
            newSets[key] = sets[key]
            break
          }
        }
      }
    }
    return newSets
  },
  displayErrorBlock (item, data) {
    return (
      <Errors show={(field) => (field.submitted || field.touched) && !field.focus}
        wrapper={(props) => <span className="error-message">{props.children}</span>}
        component={(props) => `${props.children}`}
        model={'.' + item}
        messages={{
          isRequired: 'This field is required',
          isValidLength: (val) => val && (data.minLength || data.maxLength) ? `Minimum length is ${data.minLength}` : '',
        }}
      />
    )
  },
  addDataToDisplayableSets (set, displayableSets) {
    for (let key in set) {
      if (displayableSets[key] === undefined) {
        displayableSets[key] = set[key]
      } else {
        if (Array.isArray(set[key])) {
          if (set[key][0] != null && typeof set[key][0] === 'object') {
            for (let i = 0; i < set[key].length; i++) {
              this.addDataToDisplayableSets(set[key][i], displayableSets[key][i])
            }
          } else {
            displayableSets[key] = [...new Set([...displayableSets[key], ...set[key]])]
          }
        } else if (set[key] != null && typeof set[key] === 'object') {
          this.addDataToDisplayableSets(set[key], displayableSets[key])
        }
      }
    }
  },

  getDisplayableCriteria (sets = []) {
    let displayableSets = {}
    for (let i = 0; i < sets.length; i++) {
      let set = sets[i]
      this.addDataToDisplayableSets(set, displayableSets)
    }
    return displayableSets
  },
  constructElement (item, data) {
    if (this.getElementType(data) === 'text' && item === 'simpleValue') {
      return (
        <Control.text className="form-control" model={'.address'}/>
      )
    } else if (this.getElementType(data) === 'text') {
      return (
        <Control.text className="form-control" model={'.' + item}/>
      )
      //   <span><Control.text className="form-control" model={'.' + item}
      // validators={{
      //   isRequired: (val) => data.required ? val && val.length > 0 : true,
      //     isValidLength: (val) => isCheckValidLength(val, data),
      // }} maxLength={data.maxLength ? data.maxLength : ''} updateOn="change"/>
      //   </span>)
    } else if (this.getElementType(data) === 'select') {
      return (
        <Control.select className="form-control" model={'.' + item}>
          <option></option>
          {data.allowedValues.map((val, index) => {
            return <option key={index} value={val}>{val.toString()}</option>
          })}
        </Control.select>
      )
    }
  },
  handleSubmit (search) {
    this.props.onSearchResultPageChange(1)
    this.props.searchCompanies(search, 1, this.props.pageSize)
  },
  renderFormElements (item, displayableCriteria, colWidthClass) {
    let elements = []
    if (keys(displayableCriteria[item]).length === 0) {
      elements.push(<span key={item} className={colWidthClass}>{this.renderFormElement(item, displayableCriteria[item])}</span>)
    } else {
      for (var key in displayableCriteria[item]) {
        if (displayableCriteria[item][key] !== null && !Array.isArray(displayableCriteria[item][key]) && typeof displayableCriteria[item][key] === 'object') {
          elements.push(<span key={key} className={colWidthClass}>{this.renderFormElement(key, displayableCriteria[item][key])}</span>)
        } else {
          elements.push(<span key={key} className={colWidthClass}>{this.renderFormElement(item, displayableCriteria[item])}</span>)
          break
        }
      }
    }
    return elements
  },
  renderFormElement (item, data) {
    return (
      <div className="form-group row">
        {(item === 'simpleValue')
          ? <label htmlFor=".name" className="col-lg-4 col-md-5 col-sm-5 col-xs-5 col-form-label"> Address </label>
          : <label htmlFor=".name" className="col-lg-4 col-md-5 col-sm-5 col-xs-5 col-form-label">{(item.substring(0, 1).toUpperCase() + item.substring(1)).split(/(?=[A-Z])/).join(' ')}</label>}
        <div className="col-lg-8 col-md-7 col-sm-7 col-xs-7">
          {this.constructElement(item, data)}
          {/* {displayErrorBlock(item, data)} */}
        </div>
      </div>
    )
  },
  render () {
    let criteriaSets = this.props.data
    let displayableCriteria = this.getObjects(this.getDisplayableCriteria(criteriaSets))
    let len = 0
    len = keys(displayableCriteria).length
    let colWidthClass = len > 10 ? 'col-lg-4 col-md-6 col-sm-6 col-xs-12' : (len > 5 ? 'col-lg-6 col-md-6 col-sm-6 col-xs-12' : 'col-lg-12 col-md-12 col-sm-12 col-xs-12')
    let outerColWidthClass = len <= 5 ? 'col-lg-6 col-md-6 col-sm-6 col-xs-12' : 'col-lg-12 col-md-12 col-sm-12 col-xs-12'
    return (
      <Form
        model="myForms.search.params" className='search-form'
        onSubmit={(values) => this.handleSubmit(values)}
      >
        <div className='row'>
          <div className={outerColWidthClass}>
            {keys(displayableCriteria).map((item, index) => {
              return (
                <div key={index}>
                  <div > {this.renderFormElements(item, displayableCriteria, colWidthClass)}</div>
                </div>
              )
            })}
          </div>
        </div>
        <div className='search-form-btn-ctr'>
          <button className="cs-primary-button" disabled={this.props.loader}>{this.props.loader ? <i className="fa fa-spinner fa-spin"></i> : '' }Search</button>
        </div>
      </Form>
    )
  },
})



// WEBPACK FOOTER //
// ./src/components/forms/search-form.js